import validate from "C:/inetpub/gitlab-runner/navatel.ir-new-website/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}